import { ApiClient } from './ApiClient';

export const getAnalysisLLM = (payload) => ApiClient.post('/admin/ai/analyze', payload);
